import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { RestAgendaService } from 'src/app/service/rest/agenda/rest-agenda.service';
import { AgendaCardType } from '../utils.model';
import { News } from './news.model';

@Injectable()
export class NewsRepositoryService {

  private _news: News[] = [];
  private _dataSourceNews: MatTableDataSource<News>;

  constructor(private restAgenda : RestAgendaService) { }

  public get news(): News[] {
    return this._news;
  }
  public set news(value: News[]) {
    this._news = value;
  }

  public get filteredNews(): News[] {
    return this._news.filter((news: News) => new Date(news.expireAt).getTime() > new Date().getTime());
  }

  public get dataSourceNews(): MatTableDataSource<News> {
    return this._dataSourceNews;
  }
  public set dataSourceNews(value: MatTableDataSource<News>) {
    this._dataSourceNews = value;
  }

  loadNews() : Observable<News[]> {
    return this.restAgenda.getAgendaElementsByType(AgendaCardType.NEWS);
  }

}
